import React from "react";
import GreenTick from "../clinetAssets/images/green_tick.png";
import ClientHeader from "./Partials/ClientHeader";
import ClientSideBar from "./Partials/ClientSideBar";
import { base_url_client } from "../Constants/config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const ClientThankYouWithPay = () => {

  const navigate=useNavigate();

  const storeData2 = useSelector((state) => state.saveProfilePreview);
  const {
    saveProfilePreviewData,
    loading: saveLoading,
    error: saveError,
  } = storeData2;



    const handlePayNow=()=>{
        navigate("/candidate-form/payment");
    }

    const handlePayLater=()=>{
      const msg = "Your case is in Pending Payment page";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
        window.location.replace(base_url_client + "/listing-page/pendingPayment/pending_payment/");
        
    }
  return (
    <>
       <ClientHeader/>
      <ClientSideBar activePage="dashboard"/>

      <div class="wrapper h-100 light-blue-template">
        <section class="main-content w-100 d-block">
          <div className="m-5 p-5 d-flex flex-column justify-content-center align-items-center">
            <div className="row d-flex justify-content-center align-items-center py-1 my-1">
              <img
                src={GreenTick}
                alt="green-tick"
                style={{ width: "117px", height: "117px" }}
              />
            </div>
            <div
              className="row d-flex justify-content-center align-items-center py-1 my-1"
              style={{ fontSize: "30px", fontWeight: 700 }}
            >
              Thank you
            </div>
            <div
              className="row d-flex justify-content-center align-items-center py-1 my-3"
              style={{ fontSize: "19px", fontWeight: 600 }}
            >
              All the details have been submitted.
            </div>
            <div className="row d-flex justify-content-center align-items-center py-1 my-1" style={{cursor: "pointer" }}>
            {
              saveProfilePreviewData?.show_payment=='1'? <div
                className="col btn btn-primary d-block px-5"
                style={{ minWidth: "360px", fontSize: "14px" }}
                onClick={handlePayNow}
              >
                Pay Now
              </div>:''
              }
             
            </div>
            <div className="row d-flex justify-content-center align-items-center py-1 my-1" style={{cursor: "pointer" }}>
              <div
                className="col btn btn-outline-secondary-nohover text-primary d-block px-5"
                style={{ minWidth: "360px", backgroundColor: "#EFF8FF", fontSize: "14px" }}
                onClick={handlePayLater}
              >
                Pay Later
              </div>
            </div>
          </div>
          <div className="d-flex align-items-baseline justify-content-center fixed-bottom pb-3 text-secondary" style={{fontSize: "14px"}}>Copyright © 2022 by AuthBridge. All Rights Reserved</div>
        </section>
      </div>
    </>
  );
};

export default ClientThankYouWithPay;
